import { ref, watch, onMounted, onUnmounted } from 'vue'

export function useTheme() {
  const isDark = ref(false)

  // 应用主题到 DOM
  const applyTheme = (dark: boolean) => {
    if (dark) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  // 监听系统主题变化
  const handleSystemThemeChange = (e: MediaQueryListEvent) => {
    isDark.value = e.matches
  }

  let mediaQuery: MediaQueryList | null = null

  onMounted(() => {
    // 获取系统主题偏好
    mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    isDark.value = mediaQuery.matches
    applyTheme(isDark.value)

    // 监听系统主题变化
    mediaQuery.addEventListener('change', handleSystemThemeChange)
  })

  onUnmounted(() => {
    if (mediaQuery) {
      mediaQuery.removeEventListener('change', handleSystemThemeChange)
    }
  })

  // 监听主题变化
  watch(isDark, (newDark) => {
    applyTheme(newDark)
  })

  return {
    isDark
  }
}
